import React from 'react';
import { useLayout } from '../../contexts/layout/LayoutProvider';
import { MicroUnitClassBuilder } from './builders/MicroUnitClassBuilder';
import { MicroUnitSettings, As } from './ModularTypes/MicroUnitSettings';
import './MicroUnit.css';

const MicroUnit = <T extends As>(props: MicroUnitSettings<T>) => {
  const { context } = useLayout();
  const { children, as, ...rest } = props;
  const className = MicroUnitClassBuilder.build(props, context.microUnit || {});
  const Component = (as ?? 'p') as React.ElementType;

  return (
    <Component as={as} className={`${className}`}>
      {children}
    </Component>
  );
};

export default MicroUnit;
